import React from 'react';
import { motion } from 'framer-motion';
interface ThinkingDotsProps {
  reduce: boolean;
  /** Corner the thought tail trails from — point it at Pixel's head */
  tail?: 'top-left' | 'bottom-right';
}
const EASE = [0.23, 1, 0.32, 1] as const;

/**
 * "Pixel is thinking" — an iMessage-style typing bubble: a small soft-grey pill with three
 * dots that breathe in a rolling wave, and two tiny trailing circles like a thought tail.
 */
export function ThinkingDots({
  reduce,
  tail = 'top-left'
}: ThinkingDotsProps) {
  const flip = tail === 'bottom-right';
  return <motion.div role="status" aria-label="Pixel is thinking" initial={reduce ? false : {
    opacity: 0,
    scale: 0.7,
    y: flip ? 4 : -4
  }} animate={{
    opacity: 1,
    scale: 1,
    y: 0
  }} exit={{
    opacity: 0,
    scale: 0.8,
    transition: {
      duration: 0.12,
      ease: EASE
    }
  }} transition={reduce ? {
    duration: 0
  } : {
    type: 'spring',
    stiffness: 520,
    damping: 30,
    mass: 0.6
  }} className={`relative inline-flex items-center gap-[5px] rounded-full bg-[#ECECEF] px-[12px] py-[9px] ${flip ? 'origin-bottom-right' : 'origin-top-left'}`} data-id="element-220" data-mp="2n64nn175hl1f">
      {/* Thought tail — two tiny circles trailing toward Pixel */}
      <span aria-hidden="true" className={`absolute h-[9px] w-[9px] rounded-full bg-[#ECECEF] ${flip ? '-bottom-[3px] -right-[3px]' : '-left-[3px] -top-[3px]'}`} data-id="element-221" data-mp="1t5ka0hy8h9bg" />
      <span aria-hidden="true" className={`absolute h-[4px] w-[4px] rounded-full bg-[#ECECEF] ${flip ? '-bottom-[8px] -right-[8px]' : '-left-[8px] -top-[8px]'}`} data-id="element-222" data-mp="2lu81wwdhmwxz" />

      {[0, 1, 2].map(i => <motion.span key={i} aria-hidden="true" className="relative block h-[7px] w-[7px] rounded-full bg-[#8E8E93]" animate={reduce ? {
      opacity: 0.6
    } : {
      opacity: [0.35, 1, 0.35],
      scale: [0.85, 1.1, 0.85]
    }} transition={reduce ? undefined : {
      duration: 1.1,
      repeat: Infinity,
      ease: 'easeInOut',
      delay: i * 0.18
    }} data-id="element-223" data-mp="2bx3bgkcm0fbd" />)}
    </motion.div>;
}